import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeAddDocsAddress = async ({ docId, addressId }) => {
  return await request.delete(
    `/Docs/delete_address?id=${addressId}`,
    null,
    'При удалении адреса произошла ошибка',
    'Error'
  );
};

const useDeleteDocsAddress = () => {
  const mutation = useMutation(changeAddDocsAddress, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDeleteDocsAddress: mutation.isLoading,
    deleteDocsAddress: mutation.mutateAsync,
  };
};

export default useDeleteDocsAddress;
